// extracted by mini-css-extract-plugin
export default {"storeHeader":"StoreHeader_storeHeader__Wj6ot","cart":"StoreHeader_cart__a8MpZ"};